import React, { useEffect, createElement } from 'react';
export function SEO() {
  useEffect(() => {
    // Title
    document.title = 'SGHarems.com 新加坡后宫网 | 新加坡高端伴游陪游按摩援交平台';
    // Helper to set or create meta tags
    const setMeta = (attr: string, key: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    // Meta Description
    setMeta('name', 'description', 'SGHarems.com 新加坡后宫网 — 新加坡高端伴游、陪游、按摩、援交一站式服务平台。为新加坡绅士提供优质伴游陪伴、专业按摩、娱乐休闲体验，覆盖全新加坡地区。Singapore premium escort directory, massage services, and companion platform.');
    // Meta Keywords
    setMeta('name', 'keywords', '新加坡后宫,SGHarems,新加坡伴游,新加坡陪游,新加坡按摩,新加坡援交,Singapore escort,Singapore massage,Singapore companion,新加坡高端伴游,新加坡休闲娱乐,后宫网,sg escort directory,singapore premium escort');
    // Author
    setMeta('name', 'author', 'SGHarems.com 新加坡后宫网');
    // Robots
    setMeta('name', 'robots', 'index, follow');
    // Open Graph
    setMeta('property', 'og:title', 'SGHarems.com 新加坡后宫网 | 新加坡高端伴游陪游按摩援交平台');
    setMeta('property', 'og:description', "新加坡后宫网是高端伴游陪游按摩援交一站式平台，为新加坡绅士提供优质伴游、按摩娱乐体验，覆盖全新加坡。SGHarems — Singapore's premium escort and companion directory.");
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:url', 'https://www.sgharems.com');
    setMeta('property', 'og:site_name', 'SGHarems.com 新加坡后宫网');
    setMeta('property', 'og:locale', 'zh_CN');
    setMeta('property', 'og:locale:alternate', 'en_SG');
    // Twitter Card
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', 'SGHarems.com 新加坡后宫网 | 新加坡高端伴游按摩平台');
    setMeta('name', 'twitter:description', '新加坡后宫网 — 高端伴游、陪游、按摩、援交一站式服务平台。Singapore premium escort & companion directory.');
    // Language
    document.documentElement.lang = 'zh-CN';
  }, []);
  return null;
}